

import 'core-js/stable'
import 'dom-shims'
import 'whatwg-fetch'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tools from './plugins/tools'
import api from './plugins/api'
import raf from './plugins/raf'
import scroll from './plugins/scroll'
import "@fortawesome/fontawesome-pro/css/all.css"
import VueMeta from 'vue-meta'
import VeeValidate from "vee-validate";
// import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm';
import VueCookies from 'vue-cookies'
// import Vue2TouchEvents from 'vue2-touch-events'
import SocialSharing from 'vue-social-sharing'
import VueScrollTo from 'vue-scrollto'
// import VueNumber from 'vue-number-animation'
import NProgress from 'vue-nprogress'
import '../node_modules/nprogress/nprogress.css'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false


Vue.use(tools)
Vue.use(raf)
Vue.use(api)
Vue.use(scroll)

// Vue.use(VueNumber)
Vue.use(VueAwesomeSwiper)
Vue.use(VueMeta)
Vue.component('v-select', vSelect)
Vue.use(VeeValidate);
Vue.use(SocialSharing);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 800,
  easing: "easeOut",
  offset: 0,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(VueCookies)
// Vue.use(Vue2TouchEvents)
Vue.use(NProgress)
// Vue.use(VueAnalytics, {
//   id: 'GTM-WJ6PLFB',
//   router
// })

Vue.use(VueGtm, {
  // id: 'GTM-WJ6PLFB',
  // enabled: true,
  // loadScript: true,
  // vueRouter: router
});

const nprogress = new NProgress()

router.beforeResolve((to, from, next) => {
  if (to.name) {
    nprogress.start()
  }
  next()
})

router.afterEach((to, from) => {
  nprogress.done()
  store._actions.setIsLoaded[0](true)
})

router.beforeEach((to, from, next) => {
  if(VueCookies.isKey("user_session"))
  {
    var token = VueCookies.get("user_session")

    console.log('Get userSession : ', token)
    Vue.$api.getUser(token)
    .then(response => {
      console.log('setUser', response.data.participant)
      store._actions.setUser[0](response.data.participant)
      next()
    })
  }
  else{
    Vue.$api.registerUser()
    .then(response => {
      console.log('Set userSession : ', response.data.data.token)
      VueCookies.set("user_session", response.data.data.token, "3y")
      store._actions.setUser[0]({ token: VueCookies.get("user_session") })
      next()
    })
  }
})

new Vue({
  nprogress,
  router,
  store,
  render: h => h(App),
}).$mount('#app')